import { format } from 'date-fns';
import { Link } from 'react-router-dom';

import { GlobalRecentSubset } from '@/api/types/backend-dto-types';
import { Icon } from '@/new/components/icon';

export function WhereYouLeftOff({ recentSubsets }: { recentSubsets: GlobalRecentSubset[] }) {
  if (recentSubsets.length === 0) {
    return null;
  }

  return (
    <div className="mb-6">
      <h2 className="mb-3 flex items-center gap-2 text-sm font-medium text-gray-500">
        <Icon className="lucide--history" />
        Where You Left Off
      </h2>
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {recentSubsets.map((subset) => {
          const isAllDocuments = subset.case.isAllDocuments;
          const subPath = isAllDocuments ? '' : `/subsets/${subset.caseId}`;
          const linkTo = `/matters/${subset.case.matterId}${subPath}`;

          return (
            <Link key={subset.caseId} to={linkTo}>
              <div className="group flex h-full items-center justify-between rounded-md border border-gray-200 bg-gradient-to-br from-white to-gray-50 px-4 py-2 transition-all hover:border-gray-300 hover:bg-gray-100">
                <div className="flex min-w-0 flex-1 flex-col">
                  <div className="flex items-center gap-2 text-sm text-gray-800">
                    <Icon className="lucide--folder shrink-0 text-gray-600" />
                    <span className="truncate">{subset.case.matter.name}</span>
                  </div>

                  {!isAllDocuments && (
                    <div className="mt-0.5 flex items-center gap-1.5 text-xs text-gray-500">
                      <Icon className="lucide--group shrink-0 text-gray-500" />
                      <span className="truncate">{subset.case.name}</span>
                    </div>
                  )}
                </div>

                <div className="ml-2 flex shrink-0 items-center gap-2">
                  <span className="text-[10px] text-gray-400">Viewed {format(subset.accessedAt, 'dd MMMM')}</span>
                  <Icon className="lucide--arrow-right text-gray-400 transition-transform group-hover:translate-x-0.5 group-hover:text-gray-600" />
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
